import { render, staticRenderFns } from "./TemplateCardVerifiedApp.vue?vue&type=template&id=40cbda65&scoped=true"
import script from "./TemplateCardVerifiedApp.vue?vue&type=script&lang=js"
export * from "./TemplateCardVerifiedApp.vue?vue&type=script&lang=js"
import style0 from "./TemplateCardVerifiedApp.vue?vue&type=style&index=0&id=40cbda65&prod&lang=css"
import style1 from "./TemplateCardVerifiedApp.vue?vue&type=style&index=1&id=40cbda65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cbda65",
  null
  
)

export default component.exports